import { URI } from '@/config/config';

export default async ({ rootState }, pointOfInterestId) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await fetch(
    `${URI}points-of-interest/${pointOfInterestId}`,
    opts,
  );
  const jsonResult = await response.json();

  return jsonResult;
};
